import { isEmpty } from "lodash-es";
import { useParams } from "react-router-dom";
import { PermissionNames, PermissionOperations } from "~enums/permissions";
import type { PersonResponse } from "~types/person.ts";
import type { SelectBaseSingleProperties } from "~types/selectBaseSingleProperties.ts";
import { InfinitySelect, type InfinitySelectOption } from "../InfinitySelect";

type Props = SelectBaseSingleProperties<InfinitySelectOption>;

const SelectPerson = ({ value, ...props }: Props) => {
  const { sport, organizationId } = useParams();

  const onConvertResponseIntoOptionsHandler = (response: PersonResponse) =>
    (response?.data || []).map((x) => ({ label: x.nameFullLocal, value: x.personId }));

  return (
    <InfinitySelect<PersonResponse>
      {...props}
      url={`${sport}/o/${organizationId}/persons`}
      searchParameter="nameFullLocalContains"
      sortByFieldName="nameFullLocal"
      values={isEmpty(value) ? [] : [value]}
      onConvertResponseIntoOptions={onConvertResponseIntoOptionsHandler}
      permissionName={PermissionNames.PERSON}
      permissionOperation={PermissionOperations.READ}
    />
  );
};

export default SelectPerson;
